/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Interview_Prepare_Select_JobInputs */

const en_interview_prepare_select_job = /** @type {(inputs: Interview_Prepare_Select_JobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select a job...`)
};

const de_interview_prepare_select_job = /** @type {(inputs: Interview_Prepare_Select_JobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stelle auswählen...`)
};

const fr_interview_prepare_select_job = /** @type {(inputs: Interview_Prepare_Select_JobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sélectionner un emploi...`)
};

const es_interview_prepare_select_job = /** @type {(inputs: Interview_Prepare_Select_JobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleccionar un empleo...`)
};

const it_interview_prepare_select_job = /** @type {(inputs: Interview_Prepare_Select_JobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleziona un lavoro...`)
};

const nl_interview_prepare_select_job = /** @type {(inputs: Interview_Prepare_Select_JobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selecteer een baan...`)
};

const pl_interview_prepare_select_job = /** @type {(inputs: Interview_Prepare_Select_JobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wybierz ofertę pracy...`)
};

const fi_interview_prepare_select_job = /** @type {(inputs: Interview_Prepare_Select_JobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Valitse työpaikka...`)
};

const da_interview_prepare_select_job = /** @type {(inputs: Interview_Prepare_Select_JobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vælg et job...`)
};

const sv_interview_prepare_select_job = /** @type {(inputs: Interview_Prepare_Select_JobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Välj ett jobb...`)
};

/**
* | output |
* | --- |
* | "Select a job..." |
*
* @param {Interview_Prepare_Select_JobInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const interview_prepare_select_job = /** @type {((inputs?: Interview_Prepare_Select_JobInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Interview_Prepare_Select_JobInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_interview_prepare_select_job(inputs)
	if (locale === "fr") return fr_interview_prepare_select_job(inputs)
	if (locale === "es") return es_interview_prepare_select_job(inputs)
	if (locale === "it") return it_interview_prepare_select_job(inputs)
	if (locale === "nl") return nl_interview_prepare_select_job(inputs)
	if (locale === "pl") return pl_interview_prepare_select_job(inputs)
	if (locale === "fi") return fi_interview_prepare_select_job(inputs)
	if (locale === "da") return da_interview_prepare_select_job(inputs)
	if (locale === "sv") return sv_interview_prepare_select_job(inputs)
	return en_interview_prepare_select_job(inputs)
});